/**
 * Generate options for a React Select-backed drop-down menu.
 *
 * @param pbxMap - JS object mapping PBX IDs to PBX names
 * @return {{label: string, value: *}[]}
 */
const pbxMapToOptions = (pbxMap) => {
  const _pbxMap = pbxMap ?? {};
  return Object.entries(_pbxMap).map(([pbxId, pbxName]) => ({
    value: pbxId,
    label: `${pbxName} (${pbxId})`,
  }));
};

export default pbxMapToOptions;
